module.exports = __webpack_public_path__ + "static/img/logo.ebdecbcd.png";